document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper = [];

    document.querySelectorAll('.swiper-slider').forEach((element, i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`, "");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    const topContentContainer = document.querySelector('.top-content__images-slider');
    let topContentSlider;

    if (topContentContainer) {
        topContentSlider = new Swiper('.top-content__images-slider', {
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.top-content__pagination',
                clickable: true,
            }
        });
    }

    const reviewsContainer = document.querySelector('.reviews__slider');
    let reviews;

    if (reviewsContainer) {
        reviews = new Swiper('.reviews__slider', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: false,
            speed: 1600,
            slidesPerView: 1,
            pagination: {
                el: '.reviews__pagination',
                clickable: true,
            }
        });
    }

    const fullSliderContainer = document.querySelector('.full-slider__container');
    let fullSlider;

    if (fullSliderContainer) {
        fullSlider = new Swiper('.full-slider__container', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            speed: 1600,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-next-full-slider",
                prevEl: ".swiper-prev-full-slider",
            }
        });
    }

    const galleryFeaturedContainer = document.querySelector('.gallery__featured');
    let galleryFeatured;

    if (galleryFeaturedContainer) {
        galleryFeatured = new Swiper('.gallery__featured', {
            loop: true,
            spaceBetween: 20,
            slidesPerView: 1,
            breakpoints: {
                769: {
                    slidesPerView: 2.47,
                },
                320: {
                    slidesPerView: 1
                }
            },            
        });
    }

    const galleryListContainer = document.querySelector('.gallery__list');
    let galleryList;

    if (galleryListContainer) {
        galleryList = new Swiper('.gallery__list', {
            loop: true,
            spaceBetween: 20,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-next-gallery",
                prevEl: ".swiper-prev-gallery",
            },
            controller: {
                control: '.gallery__featured'
            },
            breakpoints: {
                769: {
                    slidesPerView: 2.47,
                },
                320: {
                    slidesPerView: 1
                }                
            },
        });
    }

    const sliderTextContainer = document.querySelector('.slider-block__text');
    let sliderText;

    if (sliderTextContainer) {
        sliderText = new Swiper('.slider-block__text', {
            slidesPerView: 1,
            allowTouchMove: false,
            loop: true,
            breakpoints: {
            1280: {
                    slidesPerView: 1.3,
                    spaceBetween: 18,
                }
            },
        });
    }

    const sliderImagesContainer = document.querySelector('.slider-block__images');
    let sliderImages;

    if (sliderImagesContainer) {
        sliderImages = new Swiper('.slider-block__images', {
            slidesPerView: 1,
            allowTouchMove: false,
            navigation: {
                nextEl: ".swiper-next-slider",
                prevEl: ".swiper-prev-slider",
            },
            loop: true,
            controller: {
                control: '.slider-block__text'
            },
            breakpoints: {
                1280: {
                    slidesPerView: 1.3,
                    spaceBetween: 18,
                }
            },
        });
    }
});